// extracted by mini-css-extract-plugin
export default {"item02":"index_item02_SeXB5","num":"index_num_0Q73z","per":"index_per_IxQTz"};